import { IconButton, TableCell, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { Path } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
//
import { useContextGlobal } from '../../context/ContextGlobal';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { message } from '../../util/handleMessages';
import { FormInputProps } from '../../componets/form/formInterfaces';
import { useAuth } from '../../context/AuthContext';
import { ColumnDef } from '@tanstack/react-table';
import { IconComponent, icons } from '../../componets/icons';
import { useWindowSize } from '../../util/responsiveness';
import FormComplete from '../../componets/form/formComplete';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import { FormButton } from '../../componets/form/formButton';
import { handleExceptionMultipleMessages } from '../../util/handleExceptionAxios';

interface IItemFileTemplates {
    keyValue: string;
    keyName: string;
}
interface IFormInput {
    description: string;
    originalName: string;
    file: any;
    itemFileTemplates: IItemFileTemplates[];
}

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const params = useParams<'id' | any>();
    const history = useHistory();
    const [width] = useWindowSize();
    const [openProcessModal, setOpenProcessModal] = useState(false);
    const [openModalOriginType, setOpenModalOriginType] = useState(false);
    const { user } = useAuth();
    const { addToast } = useToast();
    const { setOpenLoading } = useContextGlobal();

    const nameFields = 'itemFileTemplates';

    const defaultValues = React.useMemo<any>(() => {
        return {};
    }, []);

    const columnsTable = React.useMemo<ColumnDef<IItemFileTemplates>[]>(
        () => [
            {
                id: 'keyName',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Nome
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            align="left"
                            key={row.id}
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            {row.original?.keyName}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'keyValue',
                cell: (cell: any) => {
                    return (
                        <TableCell
                            align="left"
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    cell.row.id,
                                    nameFields,
                                )
                            }>
                            {cell.row.original.keyValue}
                        </TableCell>
                    );
                },
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Valor
                    </TableCell>
                ),
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <IconButton
                            onClick={() =>
                                refForm?.current?.handleClick(
                                    row.id,
                                    nameFields,
                                )
                            }>
                            <IconComponent icon={icons.ModeEdit} />
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                refForm?.current?.handleDeleteItemTable(
                                    row.id,
                                    nameFields,
                                );
                            }}>
                            <IconComponent icon={icons.Delete} />
                        </IconButton>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const inputsForm = React.useMemo<FormInputProps<IFormInput>[]>(
        () => [
            {
                typeInput: 'text',
                name: 'description',
                control: null,
                label: 'Descrição do template',
                loadingAutocomplete: false,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo é obrigatório',
                    },
                ],
                md: 6,
                xs: 12,
            },
            {
                typeInput: 'text',
                name: 'whereUsed',
                control: null,
                label: 'Onde é usado',
                loadingAutocomplete: false,
                md: 6,
                xs: 12,
            },
            {
                typeInput: 'file',
                name: 'file',
                control: null,
                label: 'file',
                accept: [
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                ],
                title: 'Clique no selecionar para subir o arquivo. (Tamanho máximo: 10MB)',
                buttonText: 'Selecionar arquivo',
                maxSize: 10 * 1024 * 1024,
                setValue: null,
                md: 12,
                xs: 12,
            },
            {
                typeInput: 'component',
                name: 'code',
                control: null,
                label: 'Código',
                md: 12,
                xs: 12,
                componentProps: {
                    componentData: data => (
                        <Typography
                            sx={{ flex: '1 1 100%', fontSize: '1rem' }}
                            variant="h6"
                            id="tableTitle"
                            component="div">
                            {data?.code ? `Código: ${data['code']}` : ''}
                            <FormButton
                                label="Visualizar template"
                                typeButton="custom"
                                variant="text"
                                onClick={() => downloadTemplate()}
                                icon={<IconComponent icon={icons.Visibility} />}
                            />
                        </Typography>
                    ),
                    conditionRender: params && params.id,
                },
            },
            {
                typeInput: 'subForm',
                name: nameFields,
                control: null,
                label: 'Parâmetros',
                md: 12,
                xs: 12,
                defaultValues: {
                    x: 'x',
                },
                dto: data => {
                    if (
                        !data[nameFields] ||
                        (Array.isArray(data[nameFields]) &&
                            data[nameFields].length === 0)
                    ) {
                        delete data[nameFields];
                    }
                    return data;
                },
                dataTable: {
                    propsTable: {
                        columns: columnsTable,
                        data: [],
                        minWidth: 600,
                    },
                    inputs: [
                        {
                            typeInput: 'text',
                            name: 'keyName',
                            control: null,
                            label: 'Nome',
                            setValue: null,
                            md: 6,
                            xs: 12,
                            rules: {
                                required: true,
                            },
                            messagesError: [
                                {
                                    type: 'required',
                                    message: 'O campo é obrigatório',
                                },
                            ],
                        },
                        {
                            typeInput: 'text',
                            name: 'keyValue',
                            control: null,
                            label: 'Valor',
                            loadingAutocomplete: false,
                            md: 6,
                            xs: 12,
                            messagesError: [
                                {
                                    type: 'required',
                                    message: 'O campo é obrigatório',
                                },
                            ],
                        },
                    ] as FormInputProps<IItemFileTemplates>[],
                },
            },
        ],
        [columnsTable, refForm?.current?.dynamicFieldArrays[nameFields]],
    );

    const implSetValueData = useCallback(
        async (data: IFormInput) => {
            for (const input of inputsForm) {
                if (input?.setData) {
                    refForm?.current?.setValue(
                        input.name as Path<IFormInput>,
                        input.setData(data),
                    );
                    continue;
                }

                refForm?.current?.setValue(
                    input.name as Path<IFormInput>,
                    data[input.name as keyof IFormInput],
                );
            }

            const response = await api.get(
                `${settings.apiPath}/file/${params.id}`,
                {
                    responseType: 'blob',
                },
            );

            const file = new File([response.data], data.originalName, {
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });

            refForm?.current?.setValue('file', [file]);
        },
        [inputsForm, params.id, settings.apiPath],
    );

    const handleSave = useCallback(
        async (data: any) => {
            if (
                !refForm?.current?.watch('description') &&
                refForm?.current?.setError
            ) {
                refForm.current.setError('description', {
                    type: 'required',
                });
                return;
            }
            const formData = new FormData();
            formData.append('file', data.file[0]);
            formData.append(
                'body',
                JSON.stringify((({ file, ...o }) => o)(data)),
            );

            let response = null;
            if (params && params.id) {
                response = await api.patch(
                    `${settings.apiPath}/${params.id}`,
                    formData,
                );
            } else {
                response = await api.post(`${settings.apiPath}`, formData);
            }
            return response;
        },
        [params, settings.apiPath],
    );

    const downloadTemplate = async () => {
        const response = await api.get(
            `${settings.apiPath}/file/${params.id}`,
            {
                responseType: 'arraybuffer',
            },
        );

        console.log(refForm?.current?.data);
        console.log(refForm?.current?.watch('file'));

        let { originalName, pathFile } = refForm?.current?.data;
        let arrFileName = [];
        if (originalName === refForm?.current?.watch('file')[0]?.name) {
            originalName = originalName.replace('.docx', '');
            arrFileName.push(originalName);
        }

        if (pathFile) {
            pathFile = pathFile.replace('.docx', '');
            arrFileName.push(pathFile);
        }

        let fileName = arrFileName.join('-');

        let typeArchive = 'docx';
        if (params.type) {
            typeArchive = params.type;
        }
        const blob = new Blob([response.data], {
            type: `application/${typeArchive}`,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}.${typeArchive}`;
        link.click();
    };

    const onSubmit = async (data: any, e: any) => {
        setOpenLoading(true);

        try {
            await handleSave(data);
            addToast({
                type: 'success',
                title: message.success.save,
                description: '',
            });
            refForm?.current?.reset(defaultValues);

            history.push(`${settings.pathList}?`);
        } catch (error) {
            const messagesResponse = handleExceptionMultipleMessages(error);
            let insideErrors = false;
            for (const messageResponse of messagesResponse) {
                addToast({
                    type: 'error',
                    title: message.error.save,
                    description: messageResponse,
                });
                insideErrors = true;
            }
            if (!insideErrors) {
                addToast({
                    type: 'error',
                    title: message.error.save,
                    description: 'Algo deu errado',
                });
            }
        } finally {
            setOpenLoading(false);
        }
    };

    const handleActionButtonAfterSave = useCallback(async () => {
        let data: any = {};
        for (const input of inputsForm) {
            //
            data[input.name] = refForm?.current?.watch(
                input.name as Path<IFormInput>,
            );
        }

        try {
            let response = await handleSave(data);

            if (!response?.data) {
                return;
            }

            let { id, originalName, pathFile } = response.data;
            let arrFileName = [];
            if (originalName) {
                originalName = originalName.replace('.docx', '');
                arrFileName.push(originalName);
            }

            if (pathFile) {
                pathFile = pathFile.replace('.docx', '');
                arrFileName.push(pathFile);
            }

            let fileName = arrFileName.join('-');

            response = await api.get(
                `${settings.apiPath}/apply-file-template/${id}`,
                {
                    responseType: 'arraybuffer',
                    params,
                },
            );

            let typeArchive = 'docx';
            if (params.type) {
                typeArchive = params.type;
            }
            const blob = new Blob([response?.data], {
                type: `application/${typeArchive}`,
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${fileName}.${typeArchive}`;
            link.click();

            addToast({
                type: 'success',
                title: 'Arquivo gerado com sucesso',
                description: '',
            });
        } catch (error) {
            const messagesResponse = handleExceptionMultipleMessages(error);
            let insideErrors = false;
            for (const messageResponse of messagesResponse) {
                addToast({
                    type: 'error',
                    title: message.error.save,
                    description: messageResponse,
                });
                insideErrors = true;
            }
            if (!insideErrors) {
                addToast({
                    type: 'error',
                    title: message.error.save,
                    description: 'Algo deu errado',
                });
            }
        }
    }, [addToast, handleSave, inputsForm]);

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={inputsForm}
            ref={refForm}
            settings={settings}
            implSetValueData={implSetValueData}
            implSubmit={onSubmit}
            buttonAfterSave={
                <FormButton
                    onClick={() => handleActionButtonAfterSave()}
                    typeButton="custom"
                    variant="contained"
                    icon={<IconComponent icon={icons.Check} />}
                    label={'Aplicar e salvar'}
                    additionalDataQa="buttonAfterSave"
                />
            }
        />
    );
};

export default Form;
